import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["maxContentWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SCREEN_CONFIG } from '@config/screenConfig';
import * as React from 'react';
import { HeaderScreen as UIHeaderScreen } from '~ui/components/HeaderScreen/HeaderScreen';
import { useLayoutIsXS } from '../../Responsive/client';
import { WaiterFooter } from './WaiterFooter';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * screen wrapper that renders its children inside a layout with header bar
 * usually used as a mobile version of a screen
 */
export var HeaderScreen = function HeaderScreen(_ref) {
  var _ref$maxContentWidth = _ref.maxContentWidth,
      maxContentWidth = _ref$maxContentWidth === void 0 ? SCREEN_CONFIG.maxContentWidth : _ref$maxContentWidth,
      props = _objectWithoutProperties(_ref, _excluded);

  var isMobile = useLayoutIsXS();
  var paddingHorizontal = React.useMemo(function () {
    return isMobile ? SCREEN_CONFIG.contentPaddingHorizontalMobile : SCREEN_CONFIG.contentPaddingHorizontal;
  }, [isMobile]);
  return /*#__PURE__*/_jsx(UIHeaderScreen, _objectSpread({
    footerContent: /*#__PURE__*/_jsx(WaiterFooter, {}),
    contentPaddingHorizontal: paddingHorizontal,
    maxContentWidth: maxContentWidth,
    desktopNavMinHeight: SCREEN_CONFIG.navMinHeight
  }, props));
};